export default __webpack_public_path__ + "media/images/features/hida/access-plane-1aa7a4388b7bb0288e08f4f79316c88a.png";